import axios from '@fs/zion-axios'
import { ThingMapPin } from '@fs/zion-icon'

const CancelToken = axios.CancelToken
let source = CancelToken.source()
let outstandingRequest = false

function getPlaceOptionsFromApiResponse(response) {
  return response.data.searchResults[0].result.map((place) => {
    const fromYear = place.rep.fromYear || 'Unknown'
    const toYear = place.rep.toYear || 'Present'
    const dateRange = place.rep.fromYear || place.rep.toYear ? `, ${fromYear} - ${toYear}` : ''
    return {
      primary: place.rep.fullDisplay.name,
      secondary: `${place.rep.type.localizedName[0].name}${dateRange}`,
      key: place.rep.id,
      LeftIcon: ThingMapPin,
      placeId: place.rep.id,
    }
  })
}

function handleError(err) {
  if (axios.isCancel(err)) {
    // Discard Cancelled requests, so they can be handled separately and ignored
    console.log('Request canceled', err.message)// eslint-disable-line
    return null
  }
  // Return empty list of options on error
  return []
}

/**
 * Retrieve the appropriate list of Autosuggest options for the provided places search term.
 *
 * Only one outstanding place search request is allowed. If there are any outstanding requests
 * they are canceled before issueing a new request.
 *
 * @param {string} placesSearchTerm - The user input text to use in finding the list of matching places.
 */
export default async function fetchPlaceOptions(placesSearchTerm) {
  if (outstandingRequest) {
    source.cancel('Canceling a previously issued places request before issuing a new one!')
    source = CancelToken.source()
  }
  outstandingRequest = true
  try {
    const response = await axios.get(
      `/service/standards/place/ws/places/request?text=${encodeURI(placesSearchTerm)}&limit=5`,
      {
        headers: {
          'Content-Type': 'application/standards-places-v2+json',
          Accept: 'application/json',
        },
        cancelToken: source.token,
      }
    )
    outstandingRequest = false
    return getPlaceOptionsFromApiResponse(response)
  } catch (err) {
    outstandingRequest = false
    return handleError(err)
  }
}
